import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./MittiReports.css";
import axios from "axios";
import { config } from "../../../confi";
import Edit_form from "./Edit_form";

import Spinner from "../../Loader/Spinner";

function formatDate(date) {
  let year = date.getFullYear();
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function MittiReports() {
  const [show, setShow] = useState(false);

  const [loading, setLoading] = useState(false);
  const [msg, setmsg] = useState(false);
  const [member_reciet_no, Setmember_reciet_no] = useState("");
  const [member_data, setmember_data] = useState([]);

  const handleInputChange = (e) => {
    Setmember_reciet_no(e.target.value);
  };

  const FetchHandler = async (e) => {
    e.preventDefault();

    if (member_reciet_no.length === 0) {
      return;
    }

    let reqbody = JSON.stringify({
      fn: "common_fun",
      an: "fn_fe_mi",
      payload: { member_reciet_no: member_reciet_no },
    });

    try {
      setLoading(true);
      setShow(false);

      const response = await axios.post(
        `${config.apiBaseURL}/root`,
        { data: reqbody },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      // console.log(response.data);

      if (response.status === 200 && response.data.status === "0") {
        if (response.data.data.length > 0) {
          // console.log(response.data.data);
          setmember_data(response.data.data);
          setShow(true);
        } else {
          setmsg("Not Miti Found");
        }
      } else {
      }
    } catch (error) {}
    setLoading(false);
  };

  return (
    <>
      {loading ? (
        <span className="loading">
          <Spinner />
        </span>
      ) : (
        <div>
          {msg ? (
            <p className="msg" style={{ color: "red" }}>
              {msg}
            </p>
          ) : (
            <div className="MittiDetails">
              <div className="button-MittiDetails">
                <button>Mitti Report</button>
              </div>
              <div className="book">
                <span>View Miti Detail</span>
              </div>
              <div className="Fetch-Receipt">
                <div>
                  <label className="MittiDetails-label" htmlFor="Receipt-No">
                    Membership Receipt No
                  </label>
                  <br></br>
                  <div className="need-Fetch-Receipt">
                    <input
                      className="MittiDetails-input"
                      id="Receipt-No"
                      type="text"
                      value={member_reciet_no}
                      onChange={handleInputChange}
                    />
                    <button className="fetch-button" onClick={FetchHandler}>
                      Fetch
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {show && <Edit_form Data={member_data} />}
    </>
  );
}

export default MittiReports;
